import { parsers } from '@rdf-esm/formats-common';
import dataset from '@rdfjs/dataset';
import * as Alcaeus from "./index.mjs";
export function create(opts = {}) {
  const {
    datasetFactory,
    ...rest
  } = opts;
  return Alcaeus.create({
    fetch,
    Headers,
    parsers,
    datasetFactory: datasetFactory || dataset.dataset,
    ...rest
  });
}
export const Hydra = create();